/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Cash_FlowInputs */

const vi_dashboard_manager_cash_flow = /** @type {(inputs: Dashboard_Manager_Cash_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng tiền tháng này`)
};

/**

* @param {Dashboard_Manager_Cash_FlowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_cash_flow = /** @type {((inputs?: Dashboard_Manager_Cash_FlowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Cash_FlowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_cash_flow(inputs)
});